module.exports = __webpack_public_path__ + "static/media/r20.77add7de.png";